import { render, staticRenderFns } from "./UserProfileRecommendations.vue?vue&type=template&id=17e58dea&scoped=true&"
import script from "./UserProfileRecommendations.vue?vue&type=script&lang=js&"
export * from "./UserProfileRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileRecommendations.vue?vue&type=style&index=0&id=17e58dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e58dea",
  null
  
)

export default component.exports